import React from 'react';
import { connect } from 'react-redux';
import validate from "validate.js";
import ReCaptcha from "react-google-recaptcha"

import CaptchaTerms from '../../../../../javascript/captcha_terms/captcha_terms';
import { signupUser } from '../../../../gateway/api';
import LoginProviders from "../../login_providers";
import { signUpConstraints } from '../../../../util/validation_constraints';
import { showCloseButtonClass, errorClass, clearInputContent} from '../../../../util/form_login_utils';
import ErrorMessageComponent from '../get_error_message';

import './signup_component.scss';


const SignupComponent = ({handleChange, onButtonClick, loginObj, verifyCallback, captchaResponse, errors, clearInput, apiErrors, userLogin}) => {
  return (
    <div className="signup-component">
      {inputField(loginObj, handleChange, errors, clearInput, apiErrors)}
      <div className="toggle-login-providers toggle-login-providers__visible">
        <LoginProviders userLogin={userLogin}/>
      </div>
      <div className="buttons-container">
        {showButtonComponent({'name': 'Next'}, onButtonClick, loginObj, captchaResponse, errors)}
        {showButtonComponent({'name': 'Back'}, onButtonClick, loginObj, captchaResponse)}
      </div>
      <div className="sign-in">
        Already have an account? <a href={"/signin"  + window.location.search} className="sign-in__link">Login</a>
      </div>
    </div>
  )
}


const inputField = (loginObj={}, handleChange, errors, clearInput, apiErrors) => {
  const signupFields = [{label: "name", name: "name"}, {label: "email", name: "email"}, {label: "password", name: "password"}];
  return signupFields.map((signupField, index) => {
    return (
      <div key={index} className="input-field-container" id="input-field-container">
       <label htmlFor="textInput" className="input-label">{signupField.name}</label>
         <div className="field">
          <input type={signupField.label}
                 className={`input-field-box ${errorClass(errors, signupField.label)} ${signupField.label}`}
                 value={loginObj[signupField.name]}
                 name={signupField.name}
                 onChange={(e) => handleChange(e, loginObj, errors, apiErrors)}></input>
          <span className={`input-close-button ${showCloseButtonClass(loginObj[signupField.label])}`}
                onClick={(e) => clearInput(e, signupField.label, loginObj, errors)}></span>
        </div>
        <ErrorMessageComponent inputField={signupField.label}/>
      </div>
    )
  })
}

const showButtonComponent = (opts, onButtonClick, loginObj, captchaResponse, errors) => {
  return(
    <div className="metype-button-container">
      <button type="submit" className="metype-button" onClick={(e) => onButtonClick(e, loginObj, opts, captchaResponse, errors)}>
        {opts.name}
      </button>
    </div>
  )
}

const onNextClick = (loginObj, dispatch, captchaResponse, errors) => {
  const signUpConstraintsResponse = validate(loginObj, signUpConstraints(), { fullMessages: false }) || {};
  actionOnValidation(signUpConstraintsResponse, dispatch, loginObj, captchaResponse)
}

const actionOnValidation = (signUpConstraintsResponse, dispatch, loginObj, captchaResponse) => {
  if(!Object.keys(signUpConstraintsResponse).length) {
    signupUser( { user: { email: loginObj.email, password: loginObj.password, name: loginObj.name }, captcha_response: captchaResponse })
    .then((response) => {
      dispatch({type: 'SCREEN', screen: 'confirmOtp', source: "signUp"});
    })
      .catch((err) => {
      onSignupFailure(err, dispatch)
    });
  }
}

const onSignupFailure = (err, dispatch) => {
  const responseBody = err.res.body.error;
  const errCode = err.res.statusCode;
  actionOnExistingEmail(responseBody, errCode, dispatch);
  if (responseBody === 'Invalid captcha') {
    const captchaErrorMessage = {captchaErrorMessage: ["Invalid captcha"]};
    dispatch({type: 'ERRORS', ...captchaErrorMessage});
  }
}

const actionOnExistingEmail = (responseBody, errCode, dispatch) => {
  if(responseBody === 'Validation failed: Email has already been taken' && errCode === 422) {
    const emailError = {email: ["Email already exists"]};
    dispatch({type: 'ERRORS', ...emailError});
  }
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    loginObj: formLoginReducers.loginObj,
    captchaResponse: formLoginReducers.captchaResponse,
    errors: formLoginReducers.errors,
    apiErrors: formLoginReducers.apiErrors
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    clearInput: (e, signupFieldLabel, loginObj, errors) => {
      clearInputContent(e, signupFieldLabel, loginObj, errors, dispatch)
    },
    handleChange: (e, loginObj, errors, apiErrors) => {
      if(e.target.value.length === 0 && ((errors[e.target.name] && errors[e.target.name].length > 0))) {
        dispatch({ type: 'ERRORS', ...errors, [e.target.name]: ""});
      }
      if(e.target.value.length === 0 && Object.keys(apiErrors).length > 0) {
        dispatch({type: 'API_ERRORS', apiErrors: {}});
      }
      dispatch({ type: 'LOGIN', ...loginObj, [e.target.name]: e.target.value});
    },
    onButtonClick: (e, loginObj, opts, captchaResponse, errors) => {
      e.preventDefault();
      e.stopPropagation();

      if(opts.name === 'Next') {
        onNextClick(loginObj, dispatch, captchaResponse, errors);
      }
      else if(opts.name === 'Back') {
        window.location = '/'
      }
    },

    verifyCallback: (response) => {
      dispatch({ type: 'CAPTCHA', captchaResponse: response });
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(SignupComponent);



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/signup_component/signup_component.js